import type { AssistantSuggestionItem } from './types';

/**
 * 归一化推荐问题列表：去除空白、去掉与当前问题重复的项、去重。
 */
export const normalizeSuggestions = (
  items: AssistantSuggestionItem[],
  currentQuestion: string,
): string[] => {
  const current = currentQuestion.trim();
  const seen = new Set<string>();

  return items
    .map(item => item?.question?.trim())
    .filter((question): question is string => Boolean(question))
    .filter(question => question !== current)
    .filter((question) => {
      if (seen.has(question)) {
        return false;
      }

      seen.add(question);

      return true;
    });
};
